import { HoneycombStyleSystemProps, useHoneycombTheme } from '../../../theming';
import { getSystemStyles } from './getSystemStyles';

export function useSystemStyles(systemProps: HoneycombStyleSystemProps) {
    const { theme } = useHoneycombTheme();
    return getSystemStyles(systemProps, theme);
}
